export default "__VITE_ASSET__CPeX38ph__"